import React, { Component } from 'react'
import PropTypes from 'prop-types'


class CoreLayout extends Component {
  render() {
    return (
        <div>
          { this.props.children }
        </div>
    )
  }
}

CoreLayout.propTypes = {
  children : PropTypes.element.isRequired
}

export default CoreLayout



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js